import {
    brugereMenuLink,
    evalueringsstatistikMenuLink,
    forloebOverviewMenuLink, klarmeldingerMenuLink,
    kursusBrugerUddannelseslaegeOverviewMenuLink,
    kursusoversigtMenu
} from "core/layout/shared/MenuLinkProps";
import {DynamicMenu} from "../DynamicMenu";
import MenuProps from "./menuProps";

export function KursuslederMenu({ showNotification, nyhederMenuLink }: MenuProps) {

    const menuLinks = [
        forloebOverviewMenuLink,
        kursusBrugerUddannelseslaegeOverviewMenuLink,
        brugereMenuLink,
        klarmeldingerMenuLink,
        evalueringsstatistikMenuLink,
        nyhederMenuLink,
        kursusoversigtMenu
    ];

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );
}
